const upperCaseSentences = (value) =>
  value
    .replace(/^([a-z])/, (_, p1) => p1.toUpperCase()) // Capitalize the first letter
    .replace(
      /(\. ?)([a-z])/g,
      (_, p1, p2) => p1 + p2.toUpperCase()
    ); // Capitalize after a period

export default upperCaseSentences;
